import { get, post } from '@/api/index'
import { ref } from 'vue';

const isTest = ref<boolean>(process.env.NODE_ENV === "production");
const devUrl = ref<string>('https://scraping-apidev.tobecon.io');
const prdUrl = ref<string>('https://scraping-api.tobecon.io');

export default {
    Login(loginReq: LoginReq): Promise<CommonResponse<boolean>> {
        return post<CommonResponse<boolean>>({
            headers: { 'TOBECON-AUTH' : '9052e1eca3204473acf644de50c326ab' },
            baseURL: isTest.value ? window.location.host.includes('sandbox') ? devUrl.value : prdUrl.value : '',
            url: '/samsungfire/api/admin/login',
            data: loginReq,
            withCredentials: true
        })
    },

    Search(searchReq: SearchReq): Promise<CommonArrResponse<RejectResult>> {
        return post<CommonArrResponse<RejectResult>>({
            headers: { 'TOBECON-AUTH' : '9052e1eca3204473acf644de50c326ab' },
            baseURL: isTest.value ? window.location.host.includes('sandbox') ? devUrl.value : prdUrl.value : '',
            url: '/samsungfire/api/admin/search',
            data: searchReq,
            withCredentials: true
        })
    },

    Current(): Promise<CommonResponse<boolean>> {
        return get<CommonResponse<boolean>>({
            headers: { 'TOBECON-AUTH' : '9052e1eca3204473acf644de50c326ab' },
            baseURL: isTest.value ? window.location.host.includes('sandbox') ? devUrl.value : prdUrl.value : '',
            url: '/samsungfire/api/admin/current',
            withCredentials: true
        })
    },

    Logout(): Promise<CommonResponse<boolean>> {
        return get<CommonResponse<boolean>>({
            headers: { 'TOBECON-AUTH' : '9052e1eca3204473acf644de50c326ab' },
            baseURL: isTest.value ? window.location.host.includes('sandbox') ? devUrl.value : prdUrl.value : '',
            url: '/samsungfire/api/admin/logout',
            withCredentials: true
        })
    }
}